export default __webpack_public_path__ + "static/media/Homescreen-01.fc1f8e18.jpg";